module.exports = __webpack_public_path__ + "static/media/calculator.2841c177.svg";